import { supabase } from '../supabaseClient';
import { throttleSupabaseQuery } from '../../utils/requestThrottler';

export class WizardService {
  // WIZARD SESSION MANAGEMENT
  static async getWizardSessions() {
    try {
      const { data, error } = await supabase
        .from('wizard_sessions')
        .select(`
          *,
          wizard_exit_intents(
            id,
            intent_key,
            intent_label,
            description
          )
        `)
        .order('start_time', { ascending: false });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching wizard sessions:', error);
      throw error;
    }
  }

  static async getWizardExitIntents() {
    try {
      const { data, error } = await supabase
        .from('wizard_exit_intents')
        .select('*')
        .eq('is_active', true)
        .order('sort_order');

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching wizard exit intents:', error);
      throw error;
    }
  }

  static async updateWizardFollowUp(sessionId, followUpData) {
    try {
      const { data, error } = await supabase
        .from('wizard_sessions')
        .update({
          follow_up_status: followUpData.status,
          contact_email: followUpData.contactEmail,
          contact_phone: followUpData.contactPhone,
          notes: followUpData.notes
        })
        .eq('session_id', sessionId)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating wizard follow-up:', error);
      throw error;
    }
  }

  static async getWizardAnalytics(days = 30) {
    try {
      const { data, error } = await supabase.rpc('admin_get_wizard_analytics', { p_days: days });
      if (error) throw error;
      const payload = Array.isArray(data) ? data[0] : data;
      return {
        totalSessions: payload?.total_sessions || 0,
        activeSessions: payload?.active_sessions || 0,
        completedSessions: payload?.completed_sessions || 0,
        averageCompletionMinutes: payload?.average_completion_minutes || 0,
        dropOffRate: payload?.dropoff_rate || 0,
        stepDistribution: payload?.step_distribution || {}
      };
    } catch (error) {
      console.error('Error fetching wizard analytics:', error);
      return {
        totalSessions: 0,
        activeSessions: 0,
        completedSessions: 0,
        averageCompletionMinutes: 0,
        dropOffRate: 0,
        stepDistribution: {}
      };
    }
  }

  // Throttled version of getWizardSessions
  static async getWizardSessionsThrottled() {
    return throttleSupabaseQuery(
      async () => {
        const { data, error } = await supabase
          .from('wizard_sessions')
          .select(`
            *,
            wizard_exit_intents(
              id,
              intent_key,
              intent_label,
              description
            )
          `)
          .order('start_time', { ascending: false });

        if (error) throw error;
        return data;
      },
      'get_wizard_sessions',
      {
        retries: 2,
        useCache: false // Don't cache sessions
      }
    );
  }
}
